import React, {useEffect, useState} from 'react';
import {Button} from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {confirm} from '../../../lib/api/user';
import {useLocation, useNavigate} from 'react-router-dom';
import {add} from "../../../lib/api/club";

export const ConfirmMail = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const activation_guide = queryParams.get('activation_guide'); // <-- OVDJE se čita iz URL-a

    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (activation_guide) {
            fetchData();
        }
    }, [activation_guide]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await confirm({activation_guide});
            setItems(response);
            console.log('response', response);
        } catch (error) {
            console.error('Greška prilikom učitavanja podataka:', error);
            navigate('/errors/404');
        }
        setLoading(false);
    };

    const handleSubmit = async event => {
        event.preventDefault();
        const form = event.currentTarget;
        navigate('/authentication/simple/login');
    };

    return (
        <>
            <PageHeader
                title="Vaš nalog je uspešno aktiviran"
                description="Hvala što ste potvrdili svoju registraciju. Sada možete da se prijavite i počnete da koristite našu uslugu.."
                className="mb-3"
            >
                <Button
                    target="_blank"
                    variant="link"
                    onClick={handleSubmit}
                    size="sm"
                    className="ps-0"
                >
                    Get Started
                    <FontAwesomeIcon icon="chevron-right" className="ms-1 fs-11" />
                </Button>
            </PageHeader>

        </>
    );
};

export class Confirm {
}